import axios from "axios";
import { STORAGE_AUTH_TOKEN } from "constants/variables";
import { setCredentials } from "./credential";
import { getLocalStorageItem } from "./localStorage";

export interface ISetHostname {
  version?: string;
}

export const setHostname = (version: string = "v1") => {
  const { host } = window.location;
  // if (host.includes('pay-001')) {
  //     return 'https://stage.glorycoin.co/v1';
  // }
  if (
    host.match(/\b(dev)\b/g) &&
    !host.startsWith("dev") &&
    !host.startsWith("192.")
  ) {
    return `https://${host}/${version}`;
  }
  if (
    host.match(/localhost/g) ||
    host.match(/bs-local/g) ||
    host.includes("127.")
  ) {
    // return import.meta.env.VITE_APP_API_HOST || "https://stage.glorycoin.co/v1";
    return `/${version}`;
  }
  return `https://${host}/${version}`;
};

export const getEnv = () => {
  const { host } = window.location;
  if (
    host.match(/localhost/g) ||
    host.match(/bs-local/g) ||
    host.includes("127.")
  ) {
    return "local";
  }
  if (host.includes(".dev.")) {
    return "dev";
  }
  if (host.includes("stage.")) {
    return "stage";
  }
  return "production";
};

export const api = (
  withToken?: boolean,
  withCredentials?: boolean,
  version: string = "v1",
) => {
  const options = {
    baseURL: setHostname(version),
    headers: {
      "Content-type": "application/json",
    },
  };
  if (withToken) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    options.headers.Authorization = `Bearer ${getLocalStorageItem(STORAGE_AUTH_TOKEN)}`;
  }
  if (withCredentials) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    options.withCredentials = setCredentials();
  }
  return axios.create(options);
};
